export const seoData = {
  home: {
    title: "Zero To Cloud | The Best AWS Learning Courses",
    description: "Zero to Cloud is the #1 AWS Cloud Learning Platform, with certification preparation courses, hands-on projects, and interview mastery resources. Start learning now!",
    keywords: "AWS certification, AWS cloud computing, AWS training, AWS cloud architect, DevOps, AWS cloud engineer training, AWS projects",
    url: "https://www.zerotocloud.co"
  },
  
  courses: {
    title: "AWS Cloud Computing Courses | AWS Certification & Training",
    description: "Explore our comprehensive AWS course library with certification prep, hands-on cloud projects, and expert-led training. From beginner to advanced AWS engineer roles.",
    keywords: "AWS courses, AWS certification courses, AWS training, AWS cloud practitioner, AWS solutions architect, AWS cloud engineer",
    url: "https://www.zerotocloud.co/courses"
  },
  
  bundles: {
    title: "AWS Learning Bundles | Complete AWS Training Packages",
    description: "Save with our complete AWS learning bundles. All-in-one packages covering AWS certification, projects, and career preparation. Limited time offers available.",
    keywords: "AWS bundle, AWS training bundle, AWS certification package, AWS learning package, AWS course bundle",
    url: "https://www.zerotocloud.co/bundles"
  },
  
  learningPaths: {
    title: "AWS Career Learning Paths | AWS Cloud Roadmaps",
    description: "Follow structured learning paths to become an AWS Cloud Engineer, Solutions Architect, or Cloud Security Engineer. Clear roadmaps with projects and certifications.",
    keywords: "AWS career path, AWS learning path, AWS cloud engineer roadmap, AWS solutions architect path, AWS cloud security engineer, AWS cloud support engineer",
    url: "https://www.zerotocloud.co/learning-paths"
  },
  
  about: {
    title: "About Zero To Cloud | Learn AWS Cloud Computing with Lucy Wang",
    description: "Learn about Zero To Cloud's mission to make AWS cloud computing accessible. Meet instructor Lucy Wang and discover our approach to hands-on AWS education.",
    keywords: "about zero to cloud, Lucy Wang instructor, AWS cloud computing education, AWS instructor, AWS cloud training background",
    url: "https://www.zerotocloud.co/about"
  },
  
  cloudRoleQuiz: {
    title: "AWS Cloud Role Quiz | Find Your Perfect AWS Career Role",
    description: "Take our free AWS role quiz to discover which AWS cloud role suits you best. Get personalized recommendations for AWS cloud careers.",
    keywords: "AWS role quiz, AWS career quiz, AWS cloud computing jobs, AWS cloud engineer quiz, AWS solutions architect quiz, AWS career assessment",
    url: "https://www.zerotocloud.co/cloud-role-quiz"
  },
  
  accelerator: {
    title: "Zero To Cloud Accelerator",
    description: "Join the Zero To Cloud Accelerator program. Choose from Self-Paced, Pro Bundle, or Premium options with mentorship. Master AWS, get certified, and land your dream cloud job.",
    keywords: "AWS accelerator program, cloud career accelerator, AWS training program, cloud mentorship, AWS certification program, AWS career fast-track",
    url: "https://www.zerotocloud.co/accelerator"
  },
  
  privacy: {
    title: "Privacy Policy | Zero To Cloud",
    description: "Read our privacy policy to understand how we collect, use, and protect your personal information on Zero To Cloud platform.",
    keywords: "privacy policy, data protection, user privacy, information security",
    url: "https://www.zerotocloud.co/privacy"
  },
  
  terms: {
    title: "Terms and Conditions | Zero To Cloud",
    description: "Review our terms and conditions for using Zero To Cloud's courses, bundles, and educational content.",
    keywords: "terms of service, terms and conditions, user agreement, platform terms",
    url: "https://www.zerotocloud.co/terms"
  },
  
  // Course-specific SEO data (Original URLs)
  awsInterviewMastery: {
    title: "AWS Interview Mastery Course | Ace Your Cloud Engineer Interview",
    description: "Master AWS technical interviews with real-world scenarios, common questions, and expert tips. Get hired as an AWS Cloud Engineer or Solutions Architect.",
    keywords: "AWS interview prep, cloud engineer interview, AWS technical interview, solutions architect interview, AWS job interview",
    url: "https://www.zerotocloud.co/courses/aws-interview-mastery"
  },
  
  partTimeYouTuber: {
    title: "Part-Time Tech YouTuber Course | Build Your Tech Channel",
    description: "Learn to become a successful tech YouTuber while working full-time. Content creation, video editing, audience building, and monetization strategies.",
    keywords: "tech YouTuber course, content creation, video marketing, tech channel, YouTube monetization, content strategy",
    url: "https://www.zerotocloud.co/courses/part-time-tech-youtuber"
  },
  
  studyNotesAI: {
    title: "AWS AI Practitioner Study Notes | Complete Certification Guide",
    description: "Comprehensive study notes for AWS AI Practitioner certification. Full revision guide with key concepts, practice questions, and exam tips.",
    keywords: "AWS AI Practitioner, AI certification study notes, AWS machine learning, AI exam prep, AWS AI certification",
    url: "https://www.zerotocloud.co/courses/study-notes-ai-practitioner"
  },
  
  studyNotesCloud: {
    title: "AWS Cloud Practitioner Study Notes | Complete Certification Guide",
    description: "Complete study notes for AWS Cloud Practitioner certification. Essential concepts, services overview, and exam preparation materials.",
    keywords: "AWS Cloud Practitioner study notes, AWS CLF-C01, cloud fundamentals, AWS certification prep, cloud practitioner exam",
    url: "https://www.zerotocloud.co/courses/study-notes-cloud-practitioner"
  },
  
  studyNotesSA: {
    title: "AWS Solutions Architect Study Notes | SAA-C03 Certification Guide",
    description: "Comprehensive study notes for AWS Solutions Architect Associate certification. Architecture patterns, best practices, and exam strategies.",
    keywords: "AWS Solutions Architect study notes, SAA-C03 exam prep, AWS architecture, solutions architect certification, AWS design patterns",
    url: "https://www.zerotocloud.co/courses/study-notes-solutions-architect"
  },

  // NEW SEO Data - Matching your publicly posted URLs
  beginnerAWSProjects: {
    title: "5 Beginner AWS Cloud Projects | Hands-On AWS Training",
    description: "Build 5 beginner-friendly AWS cloud projects step-by-step. Perfect for AWS beginners to gain hands-on experience and build your cloud portfolio.",
    keywords: "beginner AWS projects, AWS hands-on training, AWS portfolio projects, cloud beginner projects, AWS practice",
    url: "https://www.zerotocloud.co/course/5-beginner-aws-cloud-projects"
  },

  intermediateAWSProjects: {
    title: "5 Intermediate AWS Cloud Projects | Advanced AWS Skills",
    description: "Master intermediate AWS concepts with 5 real-world cloud projects. Build advanced AWS skills and enhance your cloud engineering portfolio.",
    keywords: "intermediate AWS projects, AWS intermediate training, cloud portfolio, AWS skills development, hands-on AWS",
    url: "https://www.zerotocloud.co/course/5-intermediate-aws-cloud-projects"
  },

  advancedAWSProjects: {
    title: "5 Advanced AWS Cloud Projects | Expert-Level AWS Training",
    description: "Challenge yourself with 5 advanced AWS cloud projects. Master complex AWS architectures and become a cloud expert with real-world scenarios.",
    keywords: "advanced AWS projects, expert AWS training, complex AWS architecture, advanced cloud projects, AWS mastery",
    url: "https://www.zerotocloud.co/course/5-advanced-aws-cloud-projects"
  },

  aiPractitionerNotes: {
    title: "AWS AI Practitioner Study Notes | AI Certification Prep",
    description: "Complete AWS AI Practitioner study notes and certification guide. Master AI/ML concepts, services, and pass your AWS AI certification exam.",
    keywords: "AWS AI Practitioner notes, AI certification study guide, AWS machine learning certification, AI exam prep",
    url: "https://www.zerotocloud.co/course/ai-practitioner-notes"
  },

  cloudPractitionerNotes: {
    title: "AWS Cloud Practitioner Study Notes | CLF-C01 Exam Prep",
    description: "Comprehensive AWS Cloud Practitioner study notes for CLF-C01 certification. Essential AWS fundamentals and exam preparation guide.",
    keywords: "AWS Cloud Practitioner notes, CLF-C01 study guide, AWS fundamentals, cloud practitioner exam prep",
    url: "https://www.zerotocloud.co/course/cloud-practitioner-notes"
  },

  solutionsArchitectNotes: {
    title: "AWS Solutions Architect Study Notes | SAA-C03 Certification",
    description: "Master AWS Solutions Architect Associate certification with comprehensive study notes. Architecture patterns, best practices, and exam strategies.",
    keywords: "AWS Solutions Architect notes, SAA-C03 study guide, AWS architecture certification, solutions architect exam prep",
    url: "https://www.zerotocloud.co/course/solutions-architect-associate-notes"
  },

  awsInterviewMasteryNew: {
    title: "AWS Interview Mastery Course | Get Hired in Cloud",
    description: "Master AWS technical interviews and get hired as a cloud engineer. Real interview scenarios, common questions, and expert hiring tips.",
    keywords: "AWS interview mastery, cloud engineer interview, AWS job interview, get hired AWS, cloud interview prep",
    url: "https://www.zerotocloud.co/course/aws-interview-mastery"
  },

  partTimeTechYouTuber: {
    title: "Part-Time Tech Career YouTuber | Build Your Channel",
    description: "Learn to become a successful part-time tech YouTuber while working full-time. Content creation, video editing, and monetization strategies.",
    keywords: "part-time tech YouTuber, tech content creation, YouTube channel building, tech career YouTuber, content strategy",
    url: "https://www.zerotocloud.co/course/the-part-time-tech-career-youtuber"
  },

  // ADDITIONAL COURSE URLS
  freeCloudFunFacts: {
    title: "Free AWS Cloud Fun Facts Generator Project | Hands-On AWS",
    description: "Start your cloud journey with something fun. The Cloud Fun Facts Generator is a free mini-project where you'll create an app that shares surprising cloud trivia. AWS services used include DynamoDB, Bedrock, Lambda and more.",
    keywords: "free AWS project, AWS beginner project, cloud fun facts generator, AWS hands-on project, free cloud project",
    url: "https://www.zerotocloud.co/course/free-project-aws-cloud-fun-facts-generator"
  },

  awsCloudPractitionerTests: {
    title: "AWS Cloud Practitioner Practice Tests | CLF-C01 Exam Prep",
    description: "Master AWS Cloud Practitioner certification with comprehensive practice tests. Real exam scenarios, detailed explanations, and exam tips for CLF-C01.",
    keywords: "AWS Cloud Practitioner practice tests, CLF-C01 practice exam, AWS certification practice tests, cloud practitioner exam prep",
    url: "https://www.zerotocloud.co/course/aws-cloud-practitioner-practice-tests"
  },

  // BUNDLE URLS (singular)
  awsProjectsBundleSingular: {
    title: "AWS Projects Bundle | Complete Hands-On Cloud Portfolio",
    description: "Master AWS with hands-on projects bundle. Build real-world cloud applications and create an impressive portfolio for your cloud career.",
    keywords: "AWS projects bundle, cloud portfolio projects, hands-on AWS training, AWS development projects, cloud portfolio builder",
    url: "https://www.zerotocloud.co/bundle/aws-projects-bundle"
  },

  cloudNewbieBundleSingular: {
    title: "Cloud Newbie Bundle | Complete AWS Beginner Package",
    description: "Perfect bundle for cloud beginners. Complete AWS fundamentals, beginner projects, and certification prep. Start your cloud journey today.",
    keywords: "cloud newbie bundle, AWS beginner package, cloud computing beginner, AWS fundamentals bundle, cloud starter package",
    url: "https://www.zerotocloud.co/bundle/cloud-newbie-bundle"
  },

  // ADDITIONAL COURSE ROUTES
  awsCloudProjectsCloudEngineer: {
    title: "5 AWS Cloud Projects for Cloud Engineers | Hands-On AWS Training",
    description: "Master cloud engineering with 5 hands-on AWS projects. Build real-world solutions and advance your cloud engineer career with practical experience.",
    keywords: "AWS cloud engineer projects, cloud engineering projects, hands-on AWS training, AWS infrastructure projects, cloud engineer portfolio",
    url: "https://www.zerotocloud.co/course/5-aws-cloud-projects-cloud-engineer"
  },

  awsCloudProjectsSolutionsArchitect: {
    title: "5 AWS Cloud Projects to Become a Solutions Architect | Advanced AWS Training",
    description: "Become an AWS Solutions Architect with 5 advanced cloud projects. Master architecture design, scalability, and best practices through hands-on experience.",
    keywords: "AWS solutions architect projects, cloud architecture projects, AWS design patterns, solutions architect training, advanced AWS projects",
    url: "https://www.zerotocloud.co/course/5-aws-cloud-projects-to-become-a-solutions-architect"
  },

  awsCloudProjectsSecurityEngineer: {
    title: "5 AWS Projects to Become a Cloud Security Engineer | Security Training",
    description: "Master cloud security with 5 hands-on AWS projects. Learn to secure cloud infrastructure, implement IAM policies, and build security monitoring systems.",
    keywords: "AWS cloud security projects, cloud security engineer, AWS security training, IAM policies, security monitoring, cloud security architecture",
    url: "https://www.zerotocloud.co/course/5-aws-projects-to-become-a-cloud-security-engineer"
  },

  awsCertifiedAIPractitionerPracticeTests: {
    title: "AWS Certified AI Practitioner Practice Tests | AI Certification Exam Prep",
    description: "Master AWS AI Practitioner certification with comprehensive practice tests. Real exam scenarios, detailed explanations, and exam tips for AI certification.",
    keywords: "AWS AI Practitioner practice tests, AI certification practice exam, AWS machine learning practice tests, AI practitioner exam prep",
    url: "https://www.zerotocloud.co/course/aws-certified-ai-practitioner-practice-tests"
  },

  zeroToCloudAllInOneBundle: {
    title: "Zero To Cloud All-in-One Bundle | Complete AWS Training Package",
    description: "The ultimate Zero To Cloud bundle with all courses, projects, and certifications. Everything you need to become a cloud professional.",
    keywords: "zero to cloud bundle, complete AWS bundle, all-in-one cloud training, comprehensive AWS package, cloud master bundle",
    url: "https://www.zerotocloud.co/bundle/zero-to-cloud-all-in-one-bundle"
  },
  
  // Bundle-specific SEO data
  cloudNewbieBundle: {
    title: "Cloud Newbie Bundle | Complete AWS Beginner Training Package",
    description: "Perfect bundle for cloud computing beginners. Includes AWS fundamentals, hands-on projects, and certification preparation. Start your cloud journey today.",
    keywords: "AWS beginner bundle, cloud computing beginner, AWS fundamentals package, cloud newbie training, AWS starter bundle",
    url: "https://www.zerotocloud.co/bundles/cloud-newbie-bundle"
  },
  
  allInOneBundle: {
    title: "All-in-One Cloud Bundle | Complete AWS Training & Certification Package",
    description: "The ultimate cloud computing bundle with all courses, projects, and certifications. Everything you need to become a cloud professional.",
    keywords: "complete AWS bundle, all-in-one cloud training, comprehensive AWS package, cloud master bundle, AWS complete course",
    url: "https://www.zerotocloud.co/bundles/all-in-one-bundle"
  },
  
  awsProjectsBundle: {
    title: "AWS Projects Bundle | Hands-On Cloud Development Portfolio",
    description: "Build real-world AWS projects to showcase your cloud skills. Complete portfolio of hands-on projects for cloud engineers and developers.",
    keywords: "AWS projects bundle, cloud projects portfolio, hands-on AWS training, AWS development projects, cloud portfolio builder",
    url: "https://www.zerotocloud.co/bundles/aws-projects-bundle"
  }
};